import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, PageStore } from 'bernie-core';
import { Context, getBexApiContext } from 'bernie-context';

import { CustomerNotification } from '@shared-ui/customer-notifications';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

interface CustomerNotificationsProps {
  context?: Context;
  analytics?: AnalyticsStore;
  location: string;
  page?: PageStore;
}

interface Identity {
  pageId: string;
  lineOfBusiness: string;
  funnelLocation: string;
}

const getIdentity = (page: PageStore): Identity => {
  const identifiers = page.pageId.split(',').map(identifier => identifier.trim());

  return {
    pageId: identifiers[0],
    lineOfBusiness: identifiers[1],
    funnelLocation: identifiers[2]
  };
};

export const CustomerNotifications: React.FC<CustomerNotificationsProps> = inject(
  'analytics',
  'context',
  'page'
)((props: CustomerNotificationsProps) => {
  const { analytics, context, location, page } = props;

  if (!page || !page.pageId || !context) {
    return null;
  }

  const identity = getIdentity(page);
  const analyticsCallback = (rfrr: string, linkName: string | null) => {
    analytics?.trackEvent(rfrr, linkName || 'RFRR Action Event', analytics.omnitureData, null, true);
  };

  return (
    <Experiment name={'Lshop_Travel_Advisory'}>
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <div className="all-r-padding-two all-l-padding-two all-t-padding-two" data-stid="customer-notifications">
          <CustomerNotification
            inputs={{
              context: getBexApiContext(context),
              // For COVID-19 to allow the message to display for packages and avoid duplicating the config on server side
              lineOfBusiness: 'H',
              funnelLocation: identity.funnelLocation,
              notificationLocation: location
            }}
            analyticsCallback={analyticsCallback}
          />
        </div>
      </ExperimentVariant>
    </Experiment>
  );
});
